import { Tooltip, useTheme } from "@mui/material";

import { SparkleIcon } from "./SparkleIcon";
import { useSuggestionChip, UseSuggestionChipProps } from "./useSuggestionChip";

export type SuggestedChipProps = UseSuggestionChipProps & {
  tooltip?: string;
  size?: "small" | "medium" | "large";
};

export function SuggestedIcon({
  tooltip = "This field was filled in automatically using the AI tool. Please review and edit as needed.",
  isSuggested = false,
  size = "large",
}: SuggestedChipProps) {
  const theme = useTheme();

  const { showSuggestionChip } = useSuggestionChip({
    isSuggested,
  });

  if (!showSuggestionChip) {
    return null;
  }

  return (
    <Tooltip title={tooltip}>
      <SparkleIcon
        fontSize={size}
        sx={{
          marginY: theme.spacing(0.5),
          marginRight: theme.spacing(1),
          color: (theme) =>
            theme.palette.mode === "dark" ? theme.palette.grey[100] : theme.palette.grey[300],
        }}
      />
    </Tooltip>
  );
}
